class SuccessfulActionController {
  constructor($transclude) {
    'ngInject';
    this.transclude = $transclude;
  }

  $onInit() {
    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  $postLink(){
    this.hasDescriptionTextarea = this.transclude.isSlotFilled('descriptionTextarea');
  }

  dismiss() {
    this.hideModal();
    if (this.onDismiss) this.onDismiss();
    if (this.onClick) this.onClick();
  }

  hideModal() {
    if(this.modalIdToClose) {
      $('#' + this.modalIdToClose).modal('hide');
      return;
    }
    $('.modal').modal('hide');
  }

  getCssSize() {
    return {
      'size-big': angular.isDefined(this.descriptionBig)
    };
  }

  showMessage() {
    return !this.message && !this.description;
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.OK'
      }
    ];
  }
}

export default SuccessfulActionController;



// WEBPACK FOOTER //
// ./client/app/components/successfulAction/successfulAction.controller.js